import { render } from "./PackageCardTooltip.vue?vue&type=template&id=0a0ec8df&scoped=true"
import script from "./PackageCardTooltip.vue?vue&type=script&lang=js"
export * from "./PackageCardTooltip.vue?vue&type=script&lang=js"

import "./PackageCardTooltip.vue?vue&type=style&index=0&id=0a0ec8df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0ec8df"]])

export default __exports__